import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiClient } from '@/App';
import { Loader2 } from 'lucide-react';

const AuthCallback = () => {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Use useRef for processed flag - set synchronously to prevent race conditions
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        // Get session_id from URL fragment
        const hash = window.location.hash;
        const params = new URLSearchParams(hash.substring(1));
        const sessionId = params.get('session_id');

        if (!sessionId) {
          console.error('No session_id found');
          navigate('/autentificare', { replace: true });
          return;
        }

        // Exchange session_id for session_token
        const response = await apiClient.post('/auth/session', {
          session_id: sessionId
        });

        const user = response.data;

        // Clear the hash from URL and redirect to dashboard with user data
        window.history.replaceState(null, '', window.location.pathname);
        navigate('/cont', { replace: true, state: { user } });

      } catch (error) {
        console.error('Auth callback error:', error);
        navigate('/autentificare', { replace: true });
      }
    };

    processAuth();
  }, [navigate]);

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="h-8 w-8 animate-spin text-blue-600 mx-auto mb-4" />
        <p className="text-slate-600">Se procesează autentificarea...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
